
const userprofileview = [{"key":"userprofile.flash.ispublished","string":"Váš profil je zverejnený na expertnej platforme."},{"key":"userprofile.flash.unpublish","string":"Kliknutím sem zrušíte zverejnenie."},{"key":"userprofile.flash.isnotpublished","string":"Váš profil nie je zverejnený na expertnej platforme."},{"key":"userprofile.flash.publish","string":"Kliknutím sem ho zverejnite."}]

export default userprofileview



// WEBPACK FOOTER //
// ./src/i18n/sk/adduserprofile/userprofileview.js